import store from "store";
import axios from "axios";
import sha256 from "sha256";
import { doTaskActionWithCallback } from "Utils/TaskService";
import Constants from "Utils/Constants";
import toastMaker from "Common/toastmaker";
let logger = require("logger");

export const getHumanReadableTimePassedSinceThisInstance = (instanceMillis) => {
  if (!instanceMillis) {
    return {
      timeString: "No last record",
      timeapprox: "No last record",
    };
  }
  var currentTimeMillis = new Date().getTime();
  var totalSecs = Math.floor((instanceMillis - currentTimeMillis) / 1000);
  var isPast = false;
  if (totalSecs < 0) {
    isPast = true;
    totalSecs = -totalSecs;
  }
  var days = Math.floor(totalSecs / (3600 * 24));
  var hours = Math.floor((totalSecs % (3600 * 24)) / 3600);
  var minutes = Math.floor((totalSecs % 3600) / 60);
  var seconds = Math.floor(totalSecs % 60);

  let timeapprox = null;
  if (days > 0) {
    timeapprox = days + " days";
  } else if (hours > 0) {
    timeapprox = hours + " hr";
  } else if (minutes > 0) {
    timeapprox = minutes + " min";
  } else if (seconds > 0) {
    timeapprox = seconds + " sec";
  }

  var timeString =
    (days <= 0 ? "" : days + "days ") +
    (hours <= 0 ? "" : hours + "hrs ") +
    (minutes <= 0 ? "" : minutes + "mins ") +
    seconds +
    " secs";

  timeString = isPast ? "-" + timeString : timeString;
  timeapprox = isPast ? "-" + timeapprox : timeapprox;

  const timeHolder = {
    timeString,
    timeapprox,
  };

  return timeHolder;
};

export const getCityGenericNameFromNumber = function(number) {
  if (number === undefined) {
    return "Undefined";
  }
  if (number === 99 || number === "99") {
    return "Laketown";
  }
  return "City " + number;
};

export const TaskActions = {
  START_ACTION: "start",
  STOP_ACTION: "stop",
  UPDATE_STATUS_ACTION: "getstatus",
  GETDATA_ACTION: "getdata",
};

export function getData(dataparams, callbackfunc, errorhandler) {
  logger.log("here");
  var sendJSON = {
    action: TaskActions.GETDATA_ACTION,
    dataparams: dataparams,
  };
  return doTaskActionWithCallback(sendJSON, callbackfunc, errorhandler);
}

export function getPublicData(dataparams, callbackfunc, loadsilently) {
  if (!loadsilently) {
    store.dispatch({ type: "ISLOADING", payload: true });
  }
  var sendJSON = {
    dataparams,
  };
  return axios
    .post(Constants.getpublicdataApiPath, sendJSON)
    .then((response) => {
      if (!loadsilently) {
        store.dispatch({ type: "ISLOADING", payload: false });
      }
      return response;
    })
    .then(callbackfunc)
    .catch((error) => {
      if (error.response) {
        toastMaker.makeToast(error.response.data.message, {
          variant: "error",
        });
      } else {
        console.error(error, error.response);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
      throw error;
    });
}

export function getWrappedJSON(json) {
  const user = store.getState().rootScope.user;
  return {
    username: user.username,
    access_token: user.access_token,
    data: json,
  };
}

export const hashString = (plaintext) => {
  const hashed = sha256(plaintext);
  return hashed;
};

export function countTimeRemainingForEndTimeIntoVariable(timerData) {
  var mytimeout = setTimeout(onTimeout, 1000);
  var onTimeout = function() {
    var currentTimeMillis = new Date().getTime();
    var totalSecs = Math.floor(
      (timerData.endTimeMillis - currentTimeMillis) / 1000
    );
    var isPast = false;
    if (totalSecs < 0) {
      isPast = true;
      totalSecs = -totalSecs;
    }
    var days = Math.floor(totalSecs / (3600 * 24));
    var hours = Math.floor((totalSecs % (3600 * 24)) / 3600);
    var minutes = Math.floor((totalSecs % 3600) / 60);
    var seconds = Math.floor(totalSecs % 60);

    var timeString =
      (days <= 0 ? "" : days + "days ") +
      (hours <= 0 ? "" : hours + "hrs ") +
      (minutes <= 0 ? "" : minutes + "mins ") +
      seconds +
      " secs";

    timeString = isPast ? "-" + timeString : timeString;
    timerData.timeString = timeString;
    // logger.log(timerData.timeString);
    mytimeout = setTimeout(onTimeout, 1000);
  };
}

export function getTroopNameFromId(unitid) {
  var value = TROOP_NAMES[unitid];
  if (value === undefined) {
    return unitid;
  }
  //logger.log(value);
  return value;
}

export const getLastConfigForTask = (taskname) => {
  const accountdetail = store.getState().rootScope.accountdetail;
  logger.log("accountdetail", accountdetail);
  if (accountdetail.lastconfig && accountdetail.lastconfig[taskname]) {
    return accountdetail.lastconfig[taskname];
  }
  return null;
};

export const TROOP_NAMES = {
  f53: "Wall T1 Ranged",
  f54: "Wall T1 Foot",
  f55: "Wall T1 Mounted",
  u1: "Porters",
  u4: "T1 Mounted",
  u5: "T1 Foot",
  u6: "T1 Ranged",
  u9: "Supply Carts",
  u8: "T2 Mounted",
  u7: "T2 Foot",
  u11: "T2 Ranged",
  u2: "Supply Wagons",
  u10: "T3 Foot",
  u13: "T3 Mounted",
  u12: "T3 Ranged",
  u16: "T4 Mounted",
  u14: "T4 Foot",
  u15: "T4 Ranged",
  u19: "T5 Mounted",
  u17: "T5 Foot",
  u18: "T5 Ranged",
  f52: "Wall T2 Mounted",
  f56: "Wall T2 Ranged",
  f57: "Wall T2 Foot",
  f58: "Wall T3 Ranged",
  f59: "Wall T3 Foot",
  f60: "Wall T3 Mounted",
  f216: "Wall T4 Foot",
  u3: "Supply Caravans",
  u101: "Stone Giants",
  u111: "Pack Mammoths",
  u121: "Master Rangers",
  u131: "Woodmen",
  u141: "Lyncean Raiders",
  u151: "Lake-town Pikemen",
  u161: "Lake-town Longbowmen",
  u181: "Enchanters",
  u20: "Supply Columns",
};

export function getAbbreviatedNumber(value) {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = [
      " ",
      " K",
      " Million",
      " Billion",
      " Trillion",
      " K Trillions",
    ];
    var suffixNum = Math.floor(("" + value).length / 3);
    var shortValue = "";
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum !== 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      var dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 !== 0) var shortNum = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}

export const secondsToString = function(seconds) {
  var numyears = Math.floor(seconds / 31536000);
  var numdays = Math.floor((seconds % 31536000) / 86400);
  var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
  var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
  var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60;
  return (
    (numyears > 0 ? numyears + " years " : "") +
    (numdays > 0 ? numdays + " days " : "") +
    (numhours > 0 ? numhours + " hours " : "") +
    (numminutes > 0 ? numminutes + " minutes " : "") +
    (numseconds > 0 ? numseconds + " seconds" : "")
  );
};

// return the user data from the session storage
export const getUser = () => {
  return store.get("user") || null;
};

export const getStyleJSON = (style) => {
  return style2object(style);
};

// 2ⁿᵈ step logic
const camelize = (string) =>
  string.replace(/-([a-z])/gi, (s, group) => group.toUpperCase());

// 1ˢᵗ step logic which calls the 2ⁿᵈ step logic
const style2object = (style = "") =>
  style
    .split(";")
    .filter((s) => s.length)
    .reduce((a, b) => {
      b = b.trim();
      const keyValue = b.split(":");
      a[camelize(keyValue[0])] = keyValue[1];
      return a;
    }, {});

// return the token from the session storage
export const getToken = () => {
  logger.log("Get token called returning", store.getStore());
  return store.get("token") || null;
};
